import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-carousel-item',
    standalone: true,
    imports: [],
    templateUrl: './carousel-item.component.html',
    styleUrl: './carousel-item.component.scss',
})
export class CarouselItemComponent implements OnInit {
    @Input() desktop!: string;
    @Input() portrait!: string;
    @Input() mobile!: string;
    @Input() title!: string;
    @Input() description!: string;
    @Input() link!: string;
    @Input() linkText!: string;
    slug = '';

    ngOnInit(): void {
        this.slug = this.title?.toLowerCase()?.replaceAll(' ', '_');
    }

    openLink(): void {
        if (this.link && this.link.trim()) {
            // Ensure URL has protocol
            let finalUrl = this.link.trim();
            if (
                !finalUrl.startsWith('http://') &&
                !finalUrl.startsWith('https://')
            ) {
                finalUrl = 'https://' + finalUrl;
            }
            window.open(finalUrl, '_blank', 'noopener,noreferrer');
        }
    }
}
